import type { ServicioData } from './CardData';
import CardData from './CardData';
import type { CardProperties, CardRawData } from './CardData';
import styles from "../components/CardInfo.module.scss";
import i18n from "../i18n";
import {LocaleService} from "../common/LocaleService";

/** Datos crudos de una localidad, tal cual llegan del detalle REST. */
export interface PlaceCardRawData extends CardRawData {
    localidad_localidad?: string;
    tag_servicios?: ServicioData[];
    municipio?: string;
    habitantes?: string;
}

/**
 * CardData - City, Hotel
 *
 * Data wrapper for object types:
 * - Accommodation (Hotel, Hostel)
 * - Place (City, Monument)
 */
class PlaceCard extends CardData {

    // Solo estrecha el tipo del campo de CardData: `declare` no emite nada.
    declare data: PlaceCardRawData;

    constructor(type: string, properties: CardProperties, data: PlaceCardRawData) {
      super(type, properties, data);

      this.title = data.localidad_localidad;              
      if (data.tag_servicios) {
          this.tag_servicios = data.tag_servicios;
      }      

      this.geo_location = data.geo_location;
      this.bookingUrl = data.booking_url;
    }

    /**
     * Returns place[id]
     */
    getMapId(): string {
      return 'place' + this.id;   
    }

    static getCardDOM (cardData: PlaceCard) {
        const {municipio, habitantes} = cardData.data;

        return <div>
            <div className={styles.label}>{i18n.t('cardContent.place.municipio')}</div>
            <span>{municipio && LocaleService.decodeHtmlEntities(municipio)}</span>
            <div className={styles.label}>{i18n.t('cardContent.place.poblacion')}</div>
            <div>{habitantes && LocaleService.decodeHtmlEntities(habitantes)}</div>
        </div>
    }

}

export default PlaceCard;
